import jQuery from 'jquery'
import EventBus from '../../../../shared/js/wirebox/event-bus'
import '../../../../shared/js/components/form-validation'
import '../../../../shared/js/wirebox/utilities/bind-action-to-elem'

const form = jQuery('#select-plan')

if (form.length > 0) {
    form.on('form-success', () => {
        
        EventBus.publish('prepare-form-submit', form)
        
        //Define new URL
        const url = form.data('url').replace('-1', form.find('input:checked').val())
        
        if (form.data('subscribed')) {
            form.attr('action', url)
            form[0].submit()
        }
        else {
            window.location = url
        }
        
    })
}